import { useCallback } from "react";
import UAParser from "ua-parser-js";
import DesktopSVG from "assets/images/desktop.svg";
import MobileSVG from "assets/images/mobile.svg";
import styles from "./ActiveToken.module.scss";

type ActiveTokenProps = {
  data: any;
  readonly?: boolean;
  onRemoveClick?: (data: any) => void;
};

function ActiveToken({ data, readonly, onRemoveClick }: ActiveTokenProps) {
  const isDesktop = useCallback(() => {
    if (!data?.userAgent) {
      return null;
    }

    const parser = new UAParser(data.userAgent);
    const parserResults = parser.getResult();

    return (
      parserResults.device.type === undefined ||
      !["wearable", "mobile"].includes(parserResults.device.type)
    );
  }, [data.userAgent]);
  const parseUserAgent = useCallback(() => {
    if (!data?.userAgent) {
      return "_";
    }

    const parser = new UAParser(data.userAgent);
    const parserResults = parser.getResult();

    return `${parserResults.os.name} ${parserResults.os.version} | ${parserResults.engine.name} ${parserResults.engine.version} | ${parserResults.browser.name} ${parserResults.browser.version}`;
  }, [data.userAgent]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.card}>
          {isDesktop() !== null ? (
            <img src={isDesktop() ? DesktopSVG : MobileSVG} alt="نوع دستگاه" />
          ) : null}
        </div>
      </div>
      <div className={styles.description}>
        <div className={styles.column}>
          <div className={styles.title}>زمان ورود</div>
          <div className={styles.value}>
            {data?.issuedDate ? (
              <>
                {new Date(data?.issuedDate).toLocaleDateString("fa-IR")} |{" "}
                {new Date(data?.issuedDate).toLocaleTimeString("fa-IR")}
              </>
            ) : (
              "_"
            )}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.title}>سامانه</div>
          <div className={styles.value}>{data?.clientName ?? "_"}</div>
        </div>
        <div className={styles.column}>
          <div className={styles.title}>پروتکل اینترنت</div>
          <div className={styles.value}>{data?.userIp ?? "_"}</div>
        </div>
        <div className={styles.column}>
          <div className={styles.title}>مرورگر</div>
          <div className={styles.value}>{parseUserAgent()}</div>
        </div>
      </div>
      {!readonly && !data.thirdParty ? (
        <div className={styles.buttons}>
          <button
            type="button"
            onClick={() => {
              onRemoveClick!(data);
            }}
          >
            غیرفعال‌سازی نشست
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default ActiveToken;
